import PeopleIconTwo from './component.jsx'
export default PeopleIconTwo
